import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import { fontPretendard } from "@teamsparta/design-system/dist/font/font";

export const Footer = styled.footer`
  width: 100%;
  background: black;
  padding: 26px 16px 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;

  * {
    font-family: ${fontPretendard};
    line-height: 1.5;
    dd {
      margin-inline-start: 0;
    }
    ul {
      margin-block-start: 0;
    }
  }
`;

export const FooterContentWrap = styled.footer`
  display: block;
  flex-grow: 1;
  max-width: 1230px;
  width: 100%;
`;

export const FMenu = styled.section`
  width: 100%;

  ${DESKTOP} {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;
    align-items: center;
  }
`;
export const FooterNavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${DESKTOP} {
    &:nth-of-type(2) {
      margin-left: 65px;
    }
  }
`;

export const FooterLabel = styled.p`
  color: white;
  font-size: 16px;
  font-weight: bold;
  ${DESKTOP} {
    font-size: 18px;
    margin-bottom: 16px;
  }
`;

export const FooterNav = styled.ul`
  padding: 0;
  font-size: 13px;
  color: #d4d4d4;
  display: flex;
  margin-bottom: 24px;
  flex-wrap: wrap;

  ${DESKTOP} {
    font-size: 14px;
    height: inherit;
    align-items: center;
    margin: 0;
  }
`;

export const FooterNavItemWrapper = styled.li`
  padding: 0;
  margin-right: 24px;
  margin-top: 16px;
  list-style: none;
  white-space: nowrap;
  ${DESKTOP} {
    margin-top: 0;
  }
`;

export const FooterNavItem = styled.a<{ isBold: boolean }>`
  color: #d4d4d4;
  font-weight: ${({ isBold }) => (isBold ? "bold" : "normal")};
  :hover {
    color: #ffffff;
  }
`;

export const FooterSNS = styled.div`
  margin-left: auto;
`;

interface BackgroundImg {
  backgroundImg: string;
}

export const FooterSNSItem = styled.a<BackgroundImg>`
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 12px;
  background-size: 100% 100%;
  text-indent: -9999px;

  background-image: ${(props) => props.backgroundImg};
`;

export const FooterLine = styled.hr`
  width: 100%;
  border: 0.5px solid #333;
  margin: 23px 0;
`;

export const Contacts = styled.section`
  ${DESKTOP} {
    width: 536px;
    display: flex;
  }

  a {
    color: #d4d4d4;
  }
`;

export const ContactsLine = styled.ul`
  padding: 0;
  display: flex;
  font-size: 12px;
  color: #d4d4d4;
  margin-bottom: 12px;

  ${DESKTOP} {
    margin-bottom: 0;
    font-size: 14px;
  }
`;

export const ContactsLineItem = styled.li`
  padding: 0;
  margin-right: 15px;
  list-style: none;
  a {
    font-size: 12px;
  }
  ${DESKTOP} {
    margin-right: 24px;
  }
`;

export const CopyRight = styled.p`
  font-size: 12px;
  color: #8b8b8b;
  padding-top: 16px;

  ${DESKTOP} {
    text-align: right;
  }
`;

export const BottomSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${DESKTOP} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
`;
